import request from '@/utils/request';
export const fileTransferHeaders = {};
export const defaultBannerData = {
  id: 0,
  enabled: true,
  name: '',
  desktopImage: '',
  mobileImage: '',
  description: '',
  priority: 0,
  validFrom: undefined,
  validTill: undefined,
  link: undefined,
  page: undefined,
  params: undefined,
  categoryId: null,
  category: {
    id: undefined
  },
  productId: null,
  product: {
    id: undefined
  },
  dealers: []
};
export const getBanners = params => request({
  url: '/banners',
  method: 'get',
  params
});
export const getBannerById = id => request({
  url: `/banners/${id}`,
  method: 'get'
});
export const updateBanner = (id, data) => request({
  url: `/banners/${id}`,
  method: 'patch',
  data
});
export const deleteBanner = id => request({
  url: `/banners/${id}`,
  method: 'delete'
});
export const deleteBannerById = id => request({
  url: `/banners/${id}`,
  method: 'delete'
});
export const createBanner = data => request({
  url: '/banners/create',
  method: 'post',
  data
});